<template>
  <div class="loading">
	<lottie-player src="https://assets5.lottiefiles.com/packages/lf20_tJIvme.json"  background="transparent"  speed="1"  style="width: 60px; height: 60px;"  loop autoplay ></lottie-player>
    <span>We're fetching real-time transfer fees and exchange rates....</span>
  </div>
</template>
<script>

	export default {
      data(){
      	return{
      	};
      }
  }
</script>

<style lang="scss">
  .loading {
  	margin: 30px 55px 60px 55px;
    background: #f1f7f1;
    border-radius: 16px;
    padding: 45px;

    lottie-player {
   	  margin: 0 auto 30px auto;
      display: block;
    }

    span {
      text-align: center;
      display: inline-block;
      width: 100%;
      font-size: 17px;
      color: #81858B;
      font-weight: 500;
      letter-spacing: 0.016em;
      margin-left: auto;
      margin-right: auto;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Loading.vue